import * as helper from './helper';

let usernameList = [
	'Warrick',
	'Metatron',
	'Superjochen',
	'Albion',
	'Chang73',
	'TheGnome',
	'Gronk',
	'TheHandOfVecna',
	'SexBinder',
	'SuperHetero',
	'Unwashed',
	'Unchained',
	'Yugi88',
	'SpermMaster',
	'Droll2000',
	'LoverboyXXL',
	'SchwanzusLongus',
	'Jammaster',
	'Sorcy',
	'Ozy',
	'Titan',
	'YourFrenemy',
	'DrSavage',
	'Roguester',
	'Penitrator',
	'ILikeAss',
	'Tomgue',
	'Weirdinator',
	'Freak79',
	'BallsToTheWalls',
	'DancerHuman',
	'Hukarios',
	'AlphaMail',
	'Speedster',
	'Incredible',
	'Matt',
	'Frank',
	'Boris2',
	'Freddie',
	'Flaxon',
	'DarthMaul',
	'Yarden',
	'Oglaf',
	'Talisien',
	'Lauren',
	'Markgraf',
	'DerDonald',
	'Yussuf',
	'Camus',
	'Gast2491',
	'Gast4433',
	'Vrus',
	'Barton',
	'Elementor',
	'SexGod',
	'Walter1968',
	'Samuel',
	'Goronto',
	'Flexball',
	'DirtyHans',
	'Dreadmore',
	'EldritchFlame',
	'CravenEdge',
	'whist',
	'Bringer',
	'DevilInDiguise',
	'Shulk',
	'Sharin',
	'Shamlet',
	'Oktaon',
	'Oktavion',
	'Bilbo',
	'HerrDerAugenringe',
	'Schmal',
	'Schubidubidu',
	'MayFly',
	'PornAddict',
	'Pornonator',
	'BaronVonPorno',
	'plod',
	'friemz',
	'faran',
	'alistair',
	'crowley',
	'Mephistopheles',
	'Sackratt',
]

const map = {};

export function getUsernameById(id:any): string {
	if (!map.hasOwnProperty(id)) {
		helper.shuffleArray(usernameList);
		map[id] = usernameList.shift();
	}

	return map[id];
}
